/** Admin test-flow API base (configure, assign, schedule, reports, proctoring). */
export const TEST_FLOW_API = "/admin/test-flow";
